import React from 'react';
import { Image } from 'react-konva';
const pipeCleanoutImgSrc = require('../../../../media/pipes/PipeAccessories/pipe-cleanout.png');

/* instantiate the image */
const image = new window.Image();
image.src = pipeCleanoutImgSrc;

export default class PipeCleanoutComponent extends React.Component {
  render() {
      let xOffSet = (this.props.rotation === 180) ? this.props.diameter/3 : 0;
      let yOffSet = (this.props.rotation === 270) ? this.props.diameter/3 : 0;
      return (
        <Image
          image={image}
          x={this.props.x + xOffSet}
          y={this.props.y + yOffSet}
          height={this.props.diameter}
          rotation={this.props.rotation}
          width={this.props.diameter*1.5}
        />
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/PipeAccesories/pipe-cleanout.component.js